import {FacebookMessageConfirmOrderContext} from "./_context";

export const FacebookMessageConfirmOrderProvider =
    FacebookMessageConfirmOrderContext.Provider
